import AppStoreSocialBtn from "@/assets/icons/svgs/app-store-social-btn.svg";
import GooglePlaySocialBtn from "@/assets/icons/svgs/google-play-social-btn.svg";
import { Image, View } from "@/components/ui";
import { links } from "@/constants";
import { sendAnalyticData } from "@/lib/monitoring/analytics";
import { handleOpenLink } from "@/lib/platform";
import { cn } from "@/lib/utils";

import { Typography } from "../../typography";

export function GetTheAppNow({
  size = "large",
  className = "",
}: {
  size?: "small" | "large";
  className?: string;
}) {
  const sendToRudderStack = async (href: string) => {
    await handleOpenLink(href);
    sendAnalyticData({
      name: "app_download_button_click",
      values: {
        button_location: href,
      },
    });
  };
  return (
    <View
      className={cn("item grid", className, {
        "gap-2": size === "small",
        "gap-3": size === "large",
      })}
    >
      <Typography color="white" align="center">
        Get the app now!
      </Typography>

      <View className="flex items-center justify-center gap-2">
        <View
          onClick={() => sendToRudderStack(links.appStoreClientApp)}
          className={cn(
            "border-primary-border bg-primary-surface flex cursor-pointer items-center justify-center rounded-full border",
            {
              "h-[32px] w-[103px]": size === "small",
              "h-[38px] w-[122px]": size === "large",
            },
          )}
        >
          <Image src={AppStoreSocialBtn} />
        </View>
        <View
          onClick={() => sendToRudderStack(links.googlePlayClientApp)}
          className={cn(
            "border-primary-border bg-primary-surface flex cursor-pointer items-center justify-center rounded-full border",
            {
              "h-[32px] w-[103px]": size === "small",
              "h-[38px] w-[122px]": size === "large",
            },
          )}
        >
          <Image src={GooglePlaySocialBtn} />
        </View>
      </View>
    </View>
  );
}
